export const getQueryParams = (params) => {
  const queryParams = {};
  Object.keys(params).forEach((key) => {
    if (key.startsWith('dl_track_')) {
      queryParams[key.replace('dl_track_', '')] = params[key];
    } else if (key.startsWith('dl_data_')) {
      queryParams[key.replace('dl_data_', '')] = params[key];
    }
  });
  return queryParams;
};
